import { render, staticRenderFns } from "./illnessDetail.vue?vue&type=template&id=53b6bea4&scoped=true&"
import script from "./illnessDetail.vue?vue&type=script&lang=js&"
export * from "./illnessDetail.vue?vue&type=script&lang=js&"
import style0 from "./illnessDetail.vue?vue&type=style&index=0&id=53b6bea4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6bea4",
  null
  
)

export default component.exports